import React from 'react';
import {Row} from "react-bootstrap";

class ProcessOverviewPlanItem extends React.Component {
    render() {
        return (

            <Row className={"row process-overview-plan-row"}>
                <div className={"process-overview-plan-numbers col"}>
                    {this.props.planNumber}
                </div>
                <div className={"process-overview-plan col-7"}>
                    {this.props.planLabel}
                </div>
                <div className={"process-overview-plan col"}>
                    {this.props.planEstimate}
                </div>
            </Row>

        );
    }

}

export default ProcessOverviewPlanItem;